import { render, staticRenderFns } from "./PriorityCheckbox.vue?vue&type=template&id=2d02cd41&"
import script from "./PriorityCheckbox.vue?vue&type=script&lang=js&"
export * from "./PriorityCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports